import { useEffect, useState } from 'react';
import { api } from '../../api/cliente';
import type { Precos } from '../../api/tipos';

export interface EstadoPrecos {
  /** `null` enquanto carrega (e para sempre, se falhar). */
  precos: Precos | null;
  falhou: boolean;
}

/**
 * Faixas de preço e bônus de cadastro, vindos do servidor.
 *
 * `GET /creditos/precos` é público e devolve a MESMA tabela que reserva o saldo
 * na hora da busca. Escrever os valores aqui seria mais simples e passaria a
 * mentir na primeira vez que alguém ajustasse `PRECO_FAIXAS` — e o bônus some
 * sozinho quando `BONUS_CADASTRO_CENTAVOS` vira zero.
 *
 * Uma chamada só, compartilhada pela chamada principal e pela tabela de preços.
 * Roda em efeito: no prerender o HTML sai no estado "carregando", igual ao
 * primeiro quadro do navegador.
 */
export function usePrecos(): EstadoPrecos {
  const [estado, setEstado] = useState<EstadoPrecos>({
    precos: null,
    falhou: false,
  });

  useEffect(() => {
    let vivo = true;
    api<Precos>('/creditos/precos')
      .then((p) => vivo && setEstado({ precos: p, falhou: false }))
      .catch(() => vivo && setEstado({ precos: null, falhou: true }));
    return () => {
      vivo = false;
    };
  }, []);

  return estado;
}
